// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyBugSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.172 3.504a.5.5 0 0 1 .353-.612l2.415-.647a.5.5 0 0 1 .613.353l.6 2.242c.033.121.15.199.275.187a6.071 6.071 0 0 1 1.145 0 .258.258 0 0 0 .274-.187l.601-2.242a.5.5 0 0 1 .612-.353l2.415.647a.5.5 0 0 1 .354.612l-.259.966a.5.5 0 0 1-.612.354l-.483-.13a.5.5 0 0 0-.613.354l-.106.398a.257.257 0 0 0 .127.29 6.029 6.029 0 0 1 2.305 2.248c.059.1.176.151.288.121l1.714-.46a.5.5 0 0 1 .613.354l.258.966a.5.5 0 0 1-.353.613l-1.564.419a.258.258 0 0 0-.187.281c.029.237.043.478.043.722v.75c0 .138.112.25.25.25h1.25a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1.25a.25.25 0 0 0-.25.25V15c0 .244-.014.485-.043.722a.258.258 0 0 0 .187.281l1.564.42a.5.5 0 0 1 .353.612l-.258.966a.5.5 0 0 1-.613.353l-1.714-.46a.257.257 0 0 0-.288.122A5.997 5.997 0 0 1 12 21a5.998 5.998 0 0 1-5.188-2.984.257.257 0 0 0-.287-.121l-1.715.46A.5.5 0 0 1 4.198 18l-.259-.966a.5.5 0 0 1 .354-.613l1.564-.419a.258.258 0 0 0 .186-.281A6.06 6.06 0 0 1 6 15v-.75a.25.25 0 0 0-.25-.25H4.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h1.25a.25.25 0 0 0 .25-.25V11c0-.244.015-.485.043-.722a.258.258 0 0 0-.186-.281l-1.564-.42a.5.5 0 0 1-.354-.612L4.198 8a.5.5 0 0 1 .612-.353l1.715.46c.112.03.229-.022.287-.122a6.029 6.029 0 0 1 2.306-2.247.257.257 0 0 0 .127-.291l-.107-.398a.5.5 0 0 0-.612-.354l-.483.13a.5.5 0 0 1-.612-.354zM11 12h2a1 1 0 0 0 0-2h-2a1 1 0 1 0 0 2zm0 2a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyBugSolid;
